import { Post } from './types';

export const LOGO_URL = '/logo.jpg';

export const SOCIAL_LINKS = {
  twitter: 'https://x.com',
  facebook: 'https://facebook.com',
  instagram: 'https://instagram.com',
  github: 'https://github.com',
  newsletter: 'https://lincolnbransch.substack.com',
};

export const INITIAL_POSTS: Post[] = [
  // Intentionally empty.
  // Posts should come from your real source (public/posts.json, API, etc.)
  // rather than a baked-in "Welcome/Test" placeholder.
];
